import { Widget } from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { Utils } from '../../../../../../../utils/utils';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class DonutSummaryParameters implements AiSummaryTranslocoParameters {
  assembleParameters(selectedPoints: any[], widget: Widget<WidgetChartOptions>) {
    const translationKey = `widgets.ai-insights.summary.${widget.payload.type}.${
      widget.payload.donutOptions!.scoring
    }`;

    return selectedPoints.flat().map((p, idx) => ({
      translationKey: `${translationKey}.${idx === 0 ? 'first-point' : 'rest-of-points'}`,
      translationParams: {
        fieldName: FieldService.getFieldLongName(widget.payload.analyticItem),
        fieldValue: p.name,
        score: Utils.round(p.y),
      },
    }));
  }
}
